import data from './featureGuides.json';

export type FeatureGuide = { page: string; title: string; input: string; output: string; next: string; mechanism: string; terms: string };

export function getFeatureGuide(path: string): FeatureGuide | null {
  const normalized = path.replace(/\/$/, '') || '/';
  const exact = Object.entries(data).find(([route]) => route === normalized);
  const match = exact ?? Object.entries(data).find(([route]) => {
    const expected = route.split('/'), actual = normalized.split('/');
    return expected.length === actual.length && expected.every((part, i) => part.startsWith(':') ? !!actual[i] : part === actual[i]);
  });
  if (!match) return null;
  const [page, title, input, output, next] = match[1];
  return { page: page!, title: title!, input: input!, output: output!, next: next!, mechanism: mechanismFor(page!), terms: termsFor(page!) };
}

function termsFor(page: string): string {
  if (page.startsWith('Ml') || page === 'AutoTunePage') return 'IC 是预测排序与后来真实收益的相关性，不是收益率；命中率要结合样本数看。历史回填不等于上线后真实积累的预测成绩。';
  if (['AdaptiveResearchPage', 'SandboxPage', 'QuantAgentsPage', 'GridPage', 'GridResearchPage', 'LabPage', 'PairsPage', 'RpsBacktestPage'].includes(page)) return '累计收益看期末相对起点的变化；最大回撤看途中从高点跌了多少；交易次数多不代表更好，换手和费用也会增加。历史成绩与未来收益分开判断。';
  if (['PositionsPage', 'AccountsPage', 'JournalPage', 'TRecapPage', 'RiskPage', 'BrokerTradingPage'].includes(page)) return '已实现盈亏来自已卖出的交易，未实现盈亏来自仍持有部分的估值变化；入金和出金是资金转移，不是投资收益。';
  return '无数据、数据尚未更新和读取失败是不同状态。先核对来源、范围和日期，再解释数值变化。';
}

function mechanismFor(page: string): string {
  if (['AdaptiveResearchPage', 'QuantAgentsPage', 'SandboxPage', 'GridPage', 'GridResearchPage', 'PairsPage', 'CointScanPage', 'RpsBacktestPage', 'LabPage'].includes(page))
    return '股票范围决定可交易对象，历史窗口和阈值决定何时产生信号；仓位与成交规则把信号变成交易，价格变化和公司行动形成损益，费用与滑点减少收益。判断策略优势需要同区间、同成本的对照及未参与选参的数据，单次盈利不能证明因果。';
  if (['MlExperimentsPage', 'MlExperimentDetailPage', 'MlComparePage', 'MlForwardTrackingPage', 'MlJumpsPage', 'AutoTunePage'].includes(page))
    return '训练数据、特征和预测周期影响预测值；预测值与实际结果比较后才形成误差和相关性。预测准确还需经过选股、仓位、成交和成本才能转成收益，相关性高不等于账户一定赚钱。';
  if (['PositionsPage', 'BrokerTradingPage', 'JournalPage', 'TRecapPage', 'RiskPage', 'AccountsPage'].includes(page))
    return '交易及资金流水改变现金和持仓，行情变化改变持仓市值。收益应区分已实现、未实现和费用，并剔除入出金；账户余额增加可能来自入金，不能直接当成投资盈利。';
  if (['AlertsPage', 'IntradayTrackingPage', 'NotificationsPage', 'ScreenRunsPage'].includes(page))
    return '范围和阈值决定哪些观测命中规则，检查频率和重复提醒间隔影响记录数量。命中后才可能产生通知；命中次数、通知数量与交易收益是不同输出，需要沿记录追踪。';
  if (['NewsListPage', 'WatchNewsPage', 'WeChatLogPage', 'WeChatSettingsPage', 'AskPage', 'BriefingPage', 'MarketBriefPage', 'CopilotPage', 'ThemeRadarPage'].includes(page))
    return '来源、时间和筛选范围决定可见资料，分类或模型将资料转成摘要和判断。摘要可能遗漏或误解信息；需要核对原文和当时可用时间，再验证判断是否改善交易结果。';
  if (['RpsPage', 'RotationPage', 'ScannerPage', 'IndicatorBrowserPage', 'TopgunPage', 'EtfFlowPage', 'StockDetailPage', 'StockListPage', 'WatchlistPage', 'PatternsListPage', 'PatternDetailPage', 'AnalogForecastPage', 'SwingPage'].includes(page))
    return '股票范围、观察周期和条件改变比较基准与筛选结果。排名、相似度或热度只描述数据特征；要解释盈利，还需验证这些特征之后的收益、失败样本和交易成本，不能把同时出现当作因果。';
  return '本页处理入口、配置或记录，输出由所选范围和操作决定；这些操作本身不产生投资收益。先确认保存或执行状态，再到对应业务页面查看影响。';
}
